module.exports = __webpack_public_path__ + "static/Astrid-130de9abf194807f2119ba2778a3f12f.jpg";